import { all, select, put, takeEvery } from 'redux-saga/effects';
import { Action } from 'redux-actions';
import {
  deleteDeviationSuccess,
  DeleteDeviationPayload,
} from '@wix/da-shared-react/pkg/redux/deviations/actionCreators';
import { getShopItemsStreamId } from '../streams/shop';
import { POSTS_DEVIATIONS_STREAM_GROUP_ID } from '../streams/posts';
import { ShopItemType } from '../../types/shop';
import { deleteItems } from '@wix/da-shared-react/pkg/Stream/base/actions';
import { getStreamIdsByGroupId } from '@wix/da-shared-react/pkg/Stream/base/selectors';
import { getDeviationType } from '@wix/da-shared-react/pkg/DeviationViews/_helpers';
import { DeviationTypes } from '@wix/da-shared-react/pkg/types/deviation';
import { makeDeviationId } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';

function* deleteDeviationSuccessSaga(action: Action<DeleteDeviationPayload>) {
  const deviation = action.payload!.deviation;
  const deviationType = getDeviationType(deviation);
  switch (deviationType) {
    case DeviationTypes.COMMISSION:
      yield put(
        deleteItems({
          streamId: getShopItemsStreamId(ShopItemType.COMMISSIONS),
          items: [makeDeviationId(deviation)],
        })
      );
      break;
    case DeviationTypes.POLL:
    case DeviationTypes.STATUS:
    case DeviationTypes.JOURNAL:
      const postStreams = yield select(state =>
        getStreamIdsByGroupId(state, POSTS_DEVIATIONS_STREAM_GROUP_ID)
      );
      // ^ done this way because we might have
      // several stream for each deviation type
      // due to extra flags (order, filter)
      yield all(
        postStreams.map(streamId =>
          put(
            deleteItems({
              streamId,
              items: [makeDeviationId(deviation)],
            })
          )
        )
      );
      break;
    default:
    // noop
  }
}

export default [takeEvery(deleteDeviationSuccess, deleteDeviationSuccessSaga)];
